var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mask[data-v-27025457] {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n.box[data-v-27025457] {\n  width: 10rem;\n  height: 12.667rem;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -5rem;\n  margin-top: -6.333rem;\n}\n.close[data-v-27025457] {\n  position: absolute;\n  width: 0.720rem;\n  height: 0.720rem;\n  top: -0.933rem;\n  right: 0.733rem;\n  background: url(" + escape(require("../../image/closexsq.png")) + ") no-repeat;\n  background-size: 0.720rem 0.720rem;\n}\n.btn_box[data-v-27025457] {\n  position: absolute;\n  bottom: 1.467rem;\n  left: 1.280rem;\n  width: 5.120rem;\n  height: 1.280rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27025457","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/frame.vue
// module id = 305
// module chunks = 32